<div class="system-update">
  <img src="assets/img/system-update.png" />
</div>
